import type React from 'react';

import type Cropper from 'cropperjs';

import { ImageCropperSunrise } from '../imageCropper';
import { ImageUploaderSunrise } from '../imageUploader';
import type { RawMediaCropInput, UploaderMethodProps } from '../types';

type Props = {
	crop?: RawMediaCropInput | undefined;
	disabled?: boolean;
	image?: string | null;
	onImageChange: (image: string | undefined) => void;
	onImageCrop: (imageCrop: RawMediaCropInput | undefined) => void;
	onButtonClick?: () => void;
	onCancelClick?: () => void;
	uploader: UploaderMethodProps;
	onInitialized?: (instance: Cropper) => void;
};

export const ImageCropperUploader: React.FC<Props> = ({
	crop,
	disabled = false,
	image,
	onButtonClick,
	onImageCrop,
	onImageChange,
	onCancelClick,
	uploader,
	onInitialized,
}) => {
	return (
		<>
			{image && (
				<ImageCropperSunrise
					crop={crop}
					disabled={disabled}
					image={image}
					onCancelClick={onCancelClick}
					onImageChange={onImageChange}
					onImageCrop={onImageCrop}
					uploader={uploader}
					onInitialized={onInitialized}
				/>
			)}
			{!image && <ImageUploaderSunrise disabled={disabled} onButtonClick={onButtonClick} uppy={uploader.uppy} />}
		</>
	);
};
